/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Input_PlaceholderInputs */

const en_live_caption_input_placeholder = /** @type {(inputs: Live_Caption_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type a caption line and press Enter`)
};

const fr_live_caption_input_placeholder = /** @type {(inputs: Live_Caption_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez une légende et appuyez sur Entrée`)
};

const de_live_caption_input_placeholder = /** @type {(inputs: Live_Caption_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine Bildunterschrift ein und drücken Sie die Eingabetaste.`)
};

const it_live_caption_input_placeholder = /** @type {(inputs: Live_Caption_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digita una didascalia e premi Invio`)
};

const ru_live_caption_input_placeholder = /** @type {(inputs: Live_Caption_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите подпись и нажмите Enter.`)
};

const es_live_caption_input_placeholder = /** @type {(inputs: Live_Caption_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escriba una línea de pie de foto y pulse Intro.`)
};

const zh_cn2_live_caption_input_placeholder = /** @type {(inputs: Live_Caption_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入标题并按回车键`)
};

const ja_live_caption_input_placeholder = /** @type {(inputs: Live_Caption_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションの行を入力してEnterキーを押してください。`)
};

const hi_live_caption_input_placeholder = /** @type {(inputs: Live_Caption_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन की एक पंक्ति टाइप करें और एंटर दबाएं।`)
};

const pt_pt2_live_caption_input_placeholder = /** @type {(inputs: Live_Caption_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite uma legenda e pressione Enter.`)
};

/**
* | output |
* | --- |
* | "Type a caption line and press Enter" |
*
* @param {Live_Caption_Input_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_input_placeholder = /** @type {((inputs?: Live_Caption_Input_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Input_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_input_placeholder(inputs)
	if (locale === "de") return de_live_caption_input_placeholder(inputs)
	if (locale === "it") return it_live_caption_input_placeholder(inputs)
	if (locale === "ru") return ru_live_caption_input_placeholder(inputs)
	if (locale === "es") return es_live_caption_input_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_input_placeholder(inputs)
	if (locale === "ja") return ja_live_caption_input_placeholder(inputs)
	if (locale === "hi") return hi_live_caption_input_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_input_placeholder(inputs)
	return en_live_caption_input_placeholder(inputs)
});